import {api} from 'services/api';
import {ResponseData} from 'types/response-data';
import queryParams from 'utils/query-params';

const getInvoicesExport = api.injectEndpoints({
  endpoints: builder => ({
    getInvoicesExport: builder.query<Response, Request>({
      query: params => {
        return {
          method: 'GET',
          url: `export/invoices`,
          params: queryParams(params, '|'),
        };
      },
    }),
  }),
});

type Request = {};

type Response = ResponseData<{message: string}>;

export const {useLazyGetInvoicesExportQuery} = getInvoicesExport;
